import { BaseBannersClient, Banner } from "@core/types";
import { supabaseClient } from "../supabase";

class BannersClient extends BaseBannersClient {
  async getBanners(): Promise<Banner[]> {
    const { data: banners } = await supabaseClient.from("banners").select("*").throwOnError();

    return banners!.map((b): Banner => ({ id: String(b.id), imageSrc: b.image_url, link: b.link, type: b.type }));
  }
}

export default BannersClient;
